<template>
  <div class="box is-radiusless columns is-vcentered is-gapless">
    <div class="column cart-image">
      <div class="image is-square">
        <img :src="BASE_URL + '/images/' + item.imageId + '/mid'">
      </div>
    </div>
    <div class="column">
      <h3>{{ item.name }}</h3>
    </div>
    <div class="column quantity">
      <b-field label="Quantity" :message="errors.first('quantity')">
        <b-input placeholder="0" name="quantity" v-model.number="item.quantity" v-validate="{required: true}" data-vv-delay="500"></b-input>
      </b-field>
    </div>
    <div class="column">
      <h4>${{ (item.price / 100 * item.quantity).toFixed(2) }}</h4>
      <a @click="remove">Remove</a>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from '../http';

export default {
  name: 'cart-item',

  props: ['item'],

  computed: {
    BASE_URL() {
      return BASE_URL;
    },

    quantity() {
      return this.item.quantity;
    },
  },

  watch: {
    'item.quantity'(val) {
      if (this.item.quantity !== 0) {
        this.$validator.validateAll({ quantity: val }).then((valid) => {
          if (valid) {
            this.$store.dispatch('cart/add', { id: this.item.id, quantity: val });
          }
        });
      } else {
        this.remove();
      }
    },
  },

  methods: {
    remove() {
      this.$store.dispatch('cart/remove', this.item.id);
    },
  },
};
</script>

<style scoped>
.m-left {
  margin-left: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CartItem.vue